"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Images = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
var _bricksUtils = require("@titelmedia/bricks-utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ImageItem = props => {
  const imageRef = (0, _react.useRef)(null);
  const {
    galleryType,
    image,
    imageMobile,
    svg,
    link,
    parallax,
    parallaxNumber = 5,
    imagePosition,
    imageAlignment,
    svgPosition = 'center',
    credits,
    enableRotation,
    setStartRotation,
    rotationDirection,
    rotateNumber,
    wrapper,
    index
  } = props;
  const fluid = image?.fluid || image?.responsiveImage || image;
  const mobileFluid = imageMobile?.fluid || imageMobile?.responsiveImage || imageMobile;
  const isUseMobileImage = !!mobileFluid;
  const LinkItem = ({
    link,
    children
  }) => {
    return link ? _react.default.createElement(_styles.Link, {
      href: link
    }, children) : _react.default.createElement(_react.default.Fragment, null, children);
  };
  (0, _react.useEffect)(() => {
    if (!imageRef.current) return;
    let rotationAnimation;
    if (parallax) {
      _bricksUtils.gsap.matchMedia().add(`(min-width: ${_breakpoints.BREAKPOINTS.sm}px)`, () => {
        _bricksUtils.gsap.effects.parallax(imageRef?.current, {
          yPercent: parallaxNumber,
          trigger: imageRef.current
        });
      });
    }
    if (enableRotation) {
      const rotationValue = rotationDirection === 'left' ? `-${rotateNumber}` : rotateNumber;
      if (setStartRotation) {
        _bricksUtils.gsap.set(imageRef.current, {
          rotation: rotationValue
        });
      }
      rotationAnimation = _bricksUtils.gsap.effects.rotation(imageRef.current, {
        rotation: setStartRotation ? `+=${rotationValue}` : rotationValue,
        trigger: wrapper.current,
        start: '10% bottom',
        end: `+=${wrapper.current.offsetWidth + 200}`,
        scrub: 1
      });
    }
    return () => {
      if (rotationAnimation) rotationAnimation.kill();
    };
  }, [enableRotation, rotateNumber, rotationDirection, parallax, parallaxNumber]);
  return _react.default.createElement(_styles.ImageWrapper, {
    ref: imageRef,
    aspectRatio: image.aspectRatio,
    position: imagePosition,
    alignment: imageAlignment,
    index: index,
    overlay: galleryType !== 'standard'
  }, _react.default.createElement(LinkItem, {
    link: link
  }, _react.default.createElement(_styles.ImageContainer, {
    svgPosition: svgPosition
  }, _react.default.createElement(_styles.Image, {
    src: fluid.src,
    alt: fluid.alt,
    showOnlyOnDesktop: isUseMobileImage
  }), mobileFluid && _react.default.createElement(_styles.Image, {
    src: mobileFluid.src,
    alt: mobileFluid.alt,
    mobile: true
  }), svg && _react.default.createElement(_styles.Svg, {
    src: svg.src || svg
  }))), credits?.length === 1 && _react.default.createElement(_styles.ContainerCredits, {
    align: credits[0].alignment,
    padding: credits[0].padding
  }, _react.default.createElement(_styles.Credits, {
    creditsColor: credits[0].creditsColor?.hex || '#fff'
  }, credits[0].text)));
};
const Images = ({
  galleryType,
  useContainer,
  usePadding,
  images,
  enableAnimation,
  setAnimationDuration = 0.75
}) => {
  const containerRef = (0, _react.useRef)(null);
  const wrapperRef = (0, _react.useRef)(null);
  const isAnimationEnable = enableAnimation === 'true' || enableAnimation === true;
  (0, _react.useEffect)(() => {
    if (!wrapperRef.current) return;
    let fadeAnimation;
    if (isAnimationEnable) {
      fadeAnimation = _bricksUtils.gsap.effects.fade(containerRef.current, {
        duration: setAnimationDuration,
        trigger: wrapperRef.current
      });
    }
    return () => {
      if (fadeAnimation) {
        fadeAnimation.kill();
      }
    };
  }, [isAnimationEnable, setAnimationDuration]);
  return _react.default.createElement(_styles.Container, {
    ref: wrapperRef,
    useContainer: useContainer,
    usePadding: !usePadding === false
  }, _react.default.createElement(_styles.Content, {
    ref: containerRef,
    type: galleryType
  }, images?.map((item, i) => {
    return _react.default.createElement(ImageItem, _extends({
      key: `image-item-${i}`,
      index: i,
      galleryType: galleryType,
      wrapper: wrapperRef
    }, item));
  })));
};
exports.Images = Images;
//# sourceMappingURL=index.js.map